import { FC } from 'react';
import {
  FUND_INVESTMENTS_DOCUMENTS_SLUG,
  FUND_INVESTMENTS_MARKET_ADJUSTMENT_SLUG,
  FUND_INVESTMENTS_SUMMARY_SLUG,
} from 'pages/FundInvestments/common/constants';
import {
  FundInvestmentDocuments,
  FundInvestmentMarketAdjustment,
  FundInvestmentSummary,
} from 'pages/FundInvestments/pages';
import { FundInvestmentViewProps } from './FundInvestmentView.props';

const FundInvestmentView: FC<FundInvestmentViewProps> = props => {
  const { fundInvestmentTableSlugParam } = props;

  switch (fundInvestmentTableSlugParam) {
    case FUND_INVESTMENTS_SUMMARY_SLUG:
      return <FundInvestmentSummary />;

    case FUND_INVESTMENTS_MARKET_ADJUSTMENT_SLUG:
      return <FundInvestmentMarketAdjustment />;

    case FUND_INVESTMENTS_DOCUMENTS_SLUG:
      return <FundInvestmentDocuments />;

    default:
      return <h1>Not Found - Fund Investment</h1>;
  }
};

export default FundInvestmentView;
